export function getComplianceInventoryRoomsDisplayData(complianceType, locations) {
  return (locations || []).map((location) => {
    let id = ''
    let name = ''
    let type = ''
    switch (complianceType) {
      case 'METRC':
        id = location.Id
        name = location.Name
        type = location.LocationTypeName
        break
      case 'BIOTRACK':
        id = location.roomid
        name = location.name
        break
      default:
        return
    }
    return {
      id,
      name,
      type,
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/compliance.js